const company = {
    baseUrl: 'https://api.sanctionssearch.com/v2/json/reply/SearchCompanyLookup',
    apiUserId: 'api_virtusolutions',
    apiUserKey: 'pbXp5OiI86exOgUo8Hz8PzfrYK7WvmuYdS89DggXHhGT8mSSxjvKdy417GAtSwmULpt6jVU2BLzH3wuM3ozm2TUPZgc8PWfl5WiR' +
        '4XJLyDjB9v9KlYBE7042FOfcSXlOGoMfnNSeOXYxJsQEhCV1vLo63qmoRG3KsF6TS3wHfxZjlGsm9L6qbut6aRn8BEwi5neex7VognV9WfTw' +
        '80qgLMI8maTaPygLaRo8BoZb1QkXJvj6920BnqGsPh',
}

export default company



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/company.ts